import { accountService } from "../../../_services/accounts.service";
import { AuctionAnnualCustomerView } from "./auction-annual-customer-view";
import { AuctionAnnualRoot as AuctionAnnualAdminRoot } from "./auction-annual-root";

export function AuctionAnnualRoleRoot(params: { auction?: any }) {
    // Customers / proxies use the turn-acting view. Admin, auctioneer, and monitor share the
    // oversight root — monitors are forced read-only inside that screen (no controls).
    return (accountService.isCustomer || accountService.isProxyBidder) ? (
        <AuctionAnnualCustomerView auction={params.auction} />
    ) : (
        <AuctionAnnualAdminRoot auction={params.auction} />
    );
}
